import React from 'react';
import { CreatePage } from '@components/common';
import ResourceForm from '@components/common/forms/ResourceForm';

const ResourceCreatePage = () => {
    const handleTransformData = (formData) => {
        // Don't extract metadata - let ResourceForm handle it
        // Transform form data for resource creation
        return {
            ...formData,
            created_at: new Date().toISOString(),
            status: 'active'
        };
    };

    return (
        <CreatePage
            modelName="resources"
            FormComponent={ResourceForm}
            transformData={handleTransformData}
            formProps={{
                showAdvancedOptions: true
            }}
        />
    );
};

export default ResourceCreatePage;
